import { useStoreActions } from 'easy-peasy';
import { PropTypes } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { View } from '@ge/models/constants';

import desktop from './images/desktop.svg';
import lamp from './images/lamp.svg';

const Img = styled.img`
  width: 30px;
`;

const ImgBtn = styled.button`  
    &.desktop { padding: 0 !important; }  
`;

const ThemeToggle = ({ className }) => {
  const { toggleTheme } = useStoreActions((actions) => actions.prefs);

  // TODO: Use this to determine which lamp icon is shown
  // const { theme } = useStoreState((state) => state.prefs);
  const handleViewChange = () => {
    const metaViewport = document.querySelector("meta[name=viewport]");
    if (!metaViewport) return;
    metaViewport.setAttribute("content", "width=1024, initial-scale=1.0");
    localStorage.setItem('mobileAppView', View.DESKTOP);
    window.location.href = '/';
  }

  return (<>
    <ImgBtn type="button" className={`${className} desktop`} onClick={handleViewChange}>
      <Img src={desktop} alt="theme icon" />
    </ImgBtn>
    <ImgBtn type="button" className={className} onClick={toggleTheme}>
      <img src={lamp} alt="theme icon" />
    </ImgBtn>
  </>
  );
};

ThemeToggle.propTypes = {
  className: PropTypes.string,
};

ThemeToggle.defaultProps = {
  className: null,
};

export default styled(ThemeToggle)`
  padding: 10px 17px;
  border-left: solid 1px ${(props) => props.theme.themeToggle.borderColor};
  cursor: pointer;
`;
